import ProcessedPage, { Block } from 'lib/process/ProcessedPage'

export const AD_POSITION_FLOATING = -100

const addBlockSettings = (block, counter) => {
  block.settings = block.settings ?? {}
  block.settings.ad_unit_position = counter // Position number for client side support.
  block.settings.dimensions_override = block.settings.dimensions_override || []
  block.settings.is_valid = true
  block.settings.show_header = block.settings.show_header == true ? true : false

  if (block.blockType === 'ad_unit_floating') {
    block.settings.ad_unit_id = 'mp_ad_unit_FLOATING'
    block.settings.ad_unit_position = AD_POSITION_FLOATING
  } else {
    if (counter === 0) {
      block.settings.ad_unit_id = 'mp_ad_unit_TOP'
    } else if (counter > 0 && counter < 6) {
      block.settings.ad_unit_id = `mp_ad_unit_BOTTOM__${counter}`
    } else {
      block.settings.is_valid = false
    }
  }
}
//exported for testing
export function configureDTxForBlock(page: Partial<ProcessedPage>, block: Block, adUnitCounter: number) {
  const dtxConfig = page.platform_settings?.dtx_configuration
  // Guard clause: Exit if DTX configuration is missing or incomplete
  if (!dtxConfig?.bottom || !dtxConfig.floating || !dtxConfig.top) {
    block.settings.dtx_enabled = false
    return
  }

  // --- Determine if DTX is enabled for this block ---
  // A block-level setting (true/false) takes precedence.
  // If not set, it falls back to the platform-level setting.
  const isPlatformEnabled = dtxConfig.platform_enabled === true
  const isPlatformFallbackEnabled = dtxConfig.platform_dtx_fallback_to_gam === true
  if (block.settings.dtx_enabled === undefined) {
    block.settings.dtx_enabled = isPlatformEnabled
  }

  // --- Assign placement ID only if DTX is enabled ---
  if (block.settings.dtx_enabled) {
    if (block.settings.dtx_fallback_to_gam === undefined) {
      block.settings.dtx_fallback_to_gam = isPlatformFallbackEnabled
    }
    let placementId: number

    if (block.blockType === 'ad_unit_floating') {
      placementId = dtxConfig.floating
    } else if (adUnitCounter === 0) {
      placementId = dtxConfig.top
    } else {
      const bottomIndex = adUnitCounter - 1
      if (bottomIndex < dtxConfig.bottom.length) {
        placementId = dtxConfig.bottom[bottomIndex]
      }
    }

    // If a valid placement ID was found, assign it.
    // Otherwise, disable DTX for this block to prevent client-side errors.
    if (placementId) {
      block.settings.dtx_placement_id = placementId
    } else {
      block.settings.dtx_enabled = false
    }
  }
}

export default (page: Partial<ProcessedPage>) => {
  if (!page.hasAds) return
  const { headerBlocks, blocks } = page

  let adUnitCounter = 0
  for (const block of [...headerBlocks, ...blocks]) {
    if (block.blockType === 'ad_unit' || block.blockType === 'ad_unit_floating') {
      addBlockSettings(block, adUnitCounter)
      configureDTxForBlock(page, block, adUnitCounter)
      if (block.blockType !== 'ad_unit_floating') {
        adUnitCounter++
      }
    }

    if (block.blockType === 'experiment_block') {
      const { control, variant } = block.settings
      const controlIsAd = control.blockType === 'ad_unit'
      const variantIsAd = variant.blockType === 'ad_unit'

      if (controlIsAd) addBlockSettings(control, adUnitCounter)
      if (variantIsAd) addBlockSettings(variant, adUnitCounter)

      if (controlIsAd || variantIsAd) adUnitCounter++
    }
  }
}
